import React from 'react';
import PropTypes from 'prop-types';

import InfoCard from './InfoCard';
import Paragraph from './Paragraph';
import ThreeCols from '../structure/ThreeCols';
import TwoCols from '../structure/TwoCols';

const InfoCardChoices = ({
  choices, selected, small, userSelected,
}) => {
  let output;
  const cards = [];

  choices.forEach((choice) => {
    const currentId = choice.id;
    let color = 'blue';
    let leftColor = 'blue';
    let footerColor = 'blue';
    if (userSelected !== selected && selected === currentId) {
      color = 'green';
      leftColor = 'green';
      footerColor = 'green';
    }
    if (userSelected === currentId && userSelected === selected) {
      color = 'green';
      leftColor = 'blue';
      footerColor = 'multicolor';
    }
    const props = {
      color,
      leftColor,
      footerColor,
      footer: choice.footer,
      selected: selected === currentId || userSelected === currentId,
    };

    if (choices.length === 2) {
      props.justifyContent = 'center';
    }

    cards.push((
      <InfoCard {...props}>
        <Paragraph>
          {choice.content}
        </Paragraph>
      </InfoCard>
    ));
  });

  if (choices.length === 2) {
    output = (
      <TwoCols
        alignItems="stretch"
        justifyContent="flex-start"
        leftSpan={small ? 4 : 6}
        rightSpan={small ? 4 : 6}
        left={cards[0]}
        right={cards[1]}
      />
    );
  } else if (choices.length === 3) {
    output = (
      <ThreeCols
        alignItems="stretch"
        left={cards[0]}
        center={cards[1]}
        right={cards[2]}
      />
    );
  }

  return output;
};

InfoCardChoices.defaultProps = {
  small: true,
};

InfoCardChoices.propTypes = {
  selected: PropTypes.string.isRequired,
  userSelected: PropTypes.string,
  small: PropTypes.bool,
  choices: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    content: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
    footer: PropTypes.oneOfType([
      PropTypes.element,
      PropTypes.string,
    ]),
  })).isRequired,
};

export default InfoCardChoices;
